const stats = [
  { value: "20+", label: "강의 경력" },
  { value: "EBS", label: "출신 원장직강" },
  { value: "중·고등부", label: "전문 특화" },
  { value: "1:1", label: "개별 맞춤 수업" },
];

export default function StatsSection() {
  return (
    <section className="relative -mt-16 z-10 max-w-5xl mx-auto px-4 sm:px-6 lg:px-8">
      <div className="bg-white rounded-2xl shadow-xl p-6 grid grid-cols-2 md:grid-cols-4 gap-6">
        {stats.map((stat) => (
          <div key={stat.label} className="text-center">
            <p className="text-3xl font-bold text-[#2563EB]">{stat.value}</p>
            <p className="text-sm text-slate-500 mt-1">{stat.label}</p>
          </div>
        ))}
      </div>
    </section>
  );
}
